import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  DashboardTradeChartPayload,
  DashboardTradePayload,
  IDashboardCharts,
  IDashboardTradeItem,
} from '../types/app-dashboard.types';

export const appDashboardApi = createApi({
  reducerPath: 'appDashboardApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/platform/dashboard`),
  endpoints: (builder) => ({
    fetchTrades: builder.query<ApiPaginationResponse<IDashboardTradeItem[]>, DashboardTradePayload>({
      query: (payload) => ({
        url: `/trades`,
        method: 'GET',
        params: payload,
      }),
    }),
    fetchTradeCharts: builder.query<ApiResponse<IDashboardCharts>, DashboardTradeChartPayload>({
      query: (payload) => ({
        url: `/trades/charts`,
        method: 'GET',
        params: payload,
      }),
    }),
  }),
});

export const { useLazyFetchTradesQuery, useLazyFetchTradeChartsQuery } = appDashboardApi;
